import { Link } from 'react-router-dom';
import { ArrowRight } from '@phosphor-icons/react';

import { paths } from '../../routes/paths';
import pt from '../../locales/pt';
import { cn } from '../../utils/cn';

function lastSixMonths() {
  const now = new Date();
  return Array.from({ length: 6 }, (_, i) => {
    const d = new Date(now.getFullYear(), now.getMonth() - 5 + i, 1);
    return { year: d.getFullYear(), month: d.getMonth() + 1 };
  });
}

/** ds/card/selfie-cadence no .pen — trilho de 6 meses, hábito em vez de link solto. */
export function SelfieCadenceCard({ timeline = [], latestSnapshot, className }) {
  const copy = pt.dashboard.selfieCadence;
  const monthAbbr = pt.dashboard.monthAbbr;
  const months = lastSixMonths();

  const registered = new Set(
    timeline
      .filter((s) => s.is_completed !== false && s.snapshot_date)
      .map((s) => `${s.reference_year}-${s.reference_month}`),
  );
  const filledCount = months.filter((m) => registered.has(`${m.year}-${m.month}`)).length;
  const hasSnapshot = Boolean(latestSnapshot);

  return (
    <Link
      to={hasSnapshot ? paths.selfieReport(latestSnapshot.id) : paths.selfieNew}
      className={cn(
        'flex flex-col gap-space-3 rounded-ds-lg border border-border bg-card p-space-4 transition hover:bg-muted/50',
        className,
      )}
    >
      <div className="flex flex-col gap-space-1">
        <p className="type-section text-muted-foreground">{copy.eyebrow}</p>
        <p
          className={cn(
            'font-display text-type-display-metric font-bold tracking-[-0.017em]',
            hasSnapshot ? 'text-card-foreground' : 'text-muted-foreground',
          )}
        >
          {hasSnapshot
            ? `${monthAbbr[latestSnapshot.reference_month]} ${latestSnapshot.reference_year}`
            : copy.emptyReadout}
        </p>
        <p className="text-type-label font-normal text-muted-foreground">
          {hasSnapshot ? copy.sub : copy.emptySub}
        </p>
      </div>
      <div className="flex flex-col gap-space-2">
        <div className="flex items-center gap-space-1">
          {months.map((m) => {
            const filled = registered.has(`${m.year}-${m.month}`);
            return (
              <div
                key={`${m.year}-${m.month}`}
                className={cn(
                  'h-2.5 w-full rounded-ds-full',
                  filled ? 'bg-sage-500' : 'bg-track',
                )}
              />
            );
          })}
        </div>
        <div className="flex items-center justify-between text-type-label font-normal text-muted-foreground">
          <span>{monthAbbr[months[0].month].toLowerCase()}</span>
          <span>
            {copy.scaleRight.replace('{count}', String(filledCount)).replace('{total}', '6')}
          </span>
        </div>
      </div>
      <div className="flex items-center justify-between gap-space-2 border-t border-border pt-space-3">
        <span className="text-type-label font-semibold text-sage-on-tint">
          {hasSnapshot
            ? copy.footLink.replace('{month}', monthAbbr[latestSnapshot.reference_month])
            : copy.emptyCta}
        </span>
        <ArrowRight className="h-3.5 w-3.5 shrink-0 text-sage-on-tint" weight="bold" aria-hidden />
      </div>
    </Link>
  );
}

export default SelfieCadenceCard;
